import { parseHtml2EditorState } from './helpersAdmin'

export const isRichTextFieldEmpty =
  (message = 'Campo requerido.') =>
  html =>
    html && parseHtml2EditorState(html).getCurrentContent().hasText() ? undefined : message
